import { render, staticRenderFns } from "./checkout-discount.vue?vue&type=template&id=872bac26"
import script from "./checkout-discount.vue?vue&type=script&lang=ts"
export * from "./checkout-discount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872bac26')) {
      api.createRecord('872bac26', component.options)
    } else {
      api.reload('872bac26', component.options)
    }
    module.hot.accept("./checkout-discount.vue?vue&type=template&id=872bac26", function () {
      api.rerender('872bac26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/checkout-discount.vue"
export default component.exports